// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hero-tool-main-container {\n  padding: 10px;\n}\n.hero-tool-offer-sider {\n  padding-left: 16px;\n}\n.hero-tool-section-box {\n  background-color: #F5F5F7;\n  text-align: left;\n  color: #555555;\n  padding-bottom: 23px;\n  padding-top: 23px;\n  padding-left: 12px;\n  margin-bottom: 10px;\n}\n.hero-tool-section-box h2 {\n  margin: 0;\n}\n.hero-tool-title h2 {\n  color: #555555;\n  margin: 0;\n}\n", ""]);
// Exports
module.exports = exports;
